
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqXBTF3_45G7mjvNzPorqj2o_451uZGyXV59ooMBQYL6dZXw8Meta } from "/codebuild/output/src679198107/src/src/pages/faq.vue?macro=true";
import { default as menuOtMezixSCuhkJfXBKrk9L_ZksmYSnTDFOztyJs07MAMMeta } from "/codebuild/output/src679198107/src/src/pages/menu.vue?macro=true";
import { default as indexRmG8LJkuLP6_MdNiOl2XyTFX02wd7QW09bXRb1MzAw4Meta } from "/codebuild/output/src679198107/src/src/pages/index.vue?macro=true";
import { default as contactGovi9uOg_P32ioo4yl3bxCfprZEn8SK7QzvlsH7QniMMeta } from "/codebuild/output/src679198107/src/src/pages/contact.vue?macro=true";
import { default as tutorialoCWqabpWOJ10xAHDH2pW79c0e5asOUuLBA2W1uQtEAIMeta } from "/codebuild/output/src679198107/src/src/pages/tutorial.vue?macro=true";
import { default as agreementLM7pW3qaz3PJ98fMrh3YG0upqZdlU7hEGkJtSSGdt0gMeta } from "/codebuild/output/src679198107/src/src/pages/agreement.vue?macro=true";
import { default as about_45passcJKUvpPmtePGkSUaXcSBvXqplaayeYJTgyP_45wM0XDNwMeta } from "/codebuild/output/src679198107/src/src/pages/about-pass.vue?macro=true";
import { default as indexw_g_9RNUJbuiyrFLNglHyiMnPdaFemBVGMI31GFQSuIMeta } from "/codebuild/output/src679198107/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93V6BwbNino_45Eg3OItiDjrF2GvzhH5r2pDL2EBgVA9UesMeta } from "/codebuild/output/src679198107/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenances0GOcm56Saztlx4Aw_TxINGeOar23KWMp_45Wdhz5FsEUMeta } from "/codebuild/output/src679198107/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93M7Q18KBPclfaLg0gWHaSnWGEh3eMXjPkEUNw77StQp4Meta } from "/codebuild/output/src679198107/src/src/pages/notice/[id].vue?macro=true";
import { default as indexqhKwI0GywhzZu0pJ1cQe_I0QEWaNm6fixFQV1J_V6_kMeta } from "/codebuild/output/src679198107/src/src/pages/coupon/index.vue?macro=true";
import { default as indexTBRhMPSePNYBwv3ewYcURMJQsLg2Tz8V1QdDcRyZbzkMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/index.vue?macro=true";
import { default as indexnjsyps8fVsEcA2aX2yD9RQm_4542swGEZILz6zfhlBEJ8Meta } from "/codebuild/output/src679198107/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93FfrtX9pyAXlagq56J7Any_45v1lFQKn5_BH9b_45n2YiUJYMeta } from "/codebuild/output/src679198107/src/src/pages/parking/[id].vue?macro=true";
import { default as indexUO6jfyzT9Q_45whPYG8ECqUCqyQgX7mhprBVtI0tHBVTUMeta } from "/codebuild/output/src679198107/src/src/pages/history/index.vue?macro=true";
import { default as indexf_a5xU1kDVeSYnMijkz5kumEKaQsnlBJ4tiyVNocOd8Meta } from "/codebuild/output/src679198107/src/src/pages/monthly/index.vue?macro=true";
import { default as indexy_aG8Dp8KtciSR9KpmFWNRY37K2b3BbYTyWkUbTogowMeta } from "/codebuild/output/src679198107/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexubO9dSt40eea762PtDz0uGGxGbZ4eC2NE2QCMcdLOE4Meta } from "/codebuild/output/src679198107/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviGW5FpREelYZbF1_TMgmeW3EBYCntO4Dw0M9NX7OiHFMMeta } from "/codebuild/output/src679198107/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editl59wS3eDNiCID_45maUbz_z3IOALV94k7qUuOv4YsQ0nkMeta } from "/codebuild/output/src679198107/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementSyaIZCAdiX818EqjnPXZPoc9Ucusbb6HzS3GSlISuvYMeta } from "/codebuild/output/src679198107/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexbdYZulEmECi1nlNthXvb2jTVcDarTiRWyWnVMXPnKeMMeta } from "/codebuild/output/src679198107/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dk4pVizrcoKxsb9fESciOuhJ0EzSiJ8nc1VuOdEUfpZgMeta } from "/codebuild/output/src679198107/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmD8k2h_453Z6Vbni_45olDTwUFCaZzZIW1A2L2FsRGbDGI_45cMeta } from "/codebuild/output/src679198107/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index8O57Kpgu7iqzPCLnXhDMHDGansPFnXxoZK3czW99dM4Meta } from "/codebuild/output/src679198107/src/src/pages/card/create/index.vue?macro=true";
import { default as indexIJY1THuTqbvbU3nb5DdlncozI2h_45pUo5k_45SbYM553a0Meta } from "/codebuild/output/src679198107/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmyHGNjV2EsrV9w7MnbNoF1MKFwQib3GRpY2m6pr39CRoMeta } from "/codebuild/output/src679198107/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm02_450d2GDhuvCxtFQPbMPAcew5arsZavX9mJtG6V7CHwMeta } from "/codebuild/output/src679198107/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeF6j7OXzTc5TB_459tzXY0Bf2k3bxXARnYZ3fOpZdQs9P8Meta } from "/codebuild/output/src679198107/src/src/pages/membership/complete.vue?macro=true";
import { default as registersoIbhQtakEGRttPsrp8YLnowNi9Fk8bn0c3WpODB750Meta } from "/codebuild/output/src679198107/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93lrJluK5LMJUN3775_45hoa7FBoyoPudTsxnDmsXPp7ObgMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmd1ZwxvEuDdF_h73MGLMoEJ2HN9frxlGznYwIqeaxWlQMeta } from "/codebuild/output/src679198107/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93w8v1oYWJnjfTSsV2Ycbh08A5AdwlaEHsyk_454QoWtGHsMeta } from "/codebuild/output/src679198107/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexL8CTttW_45vW6lbxfY_eFdPuGcMyOuzAAp7Nvc7AxwrMoMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codePxw6gCYoIZoRzUS9fUcqoA9q8hr_4570qyfYsHH_cWbT0Meta } from "/codebuild/output/src679198107/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeq80dyD3Chf1y6RGcalvnfW_igxi2pd8DlnlyVrUbikcMeta } from "/codebuild/output/src679198107/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completevHM6tU8uH7oWdCk9Pt8NuIgWfTp_45JAuJGP5ZDy5YypEMeta } from "/codebuild/output/src679198107/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerNU1qqcXoS42a3msgslCXYYl4JfV6crIWc1VUx1SJqdsMeta } from "/codebuild/output/src679198107/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeRSyYq_45KF340d2sj8qCAbxXVGEGmrePrBL2hcYSFVAGQMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexsfCB_qCvZCMgW6af1tQIYXt4mW3jveUdY4HIBvEcCTkMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmf1A3H8Fz4Ik6W8UCug_hu9z4YI2B_45t3IziwHUulxA3QMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeHd1V4TMs5lLYBM7JsXN44NyhP76tmIL7PPBa946DfKwMeta } from "/codebuild/output/src679198107/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexgpJquRuzOL_PNzqjWTSDtnHV2GpIpsmi32QKCuzFbrkMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ExeGFaHIhwhxdK_45oaf3g9VuNXYzwlgEe3_45WgY19WkqoMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completebwp3utEtcw2uY3wtNeHQ4gP1A0eGUp66yzjArDOZlAYMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasgvJbuAapVjZ2F_45ZHqqhz6M1EH1o5iFs4bHcBa7CU9_8Meta } from "/codebuild/output/src679198107/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample2cWq1yZH0yw6K1aMcEkWXZRI6vzLdM_s6itjIkSVMnkMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailBtHJy84As0Me_457v2hi5I6wbfJnPjNEdx9hnvb1KiGjUMeta } from "/codebuild/output/src679198107/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmgd0nUwhGipJt_ljKvl4JnEyg_G5y0uDFkT4PSJeLr_45MMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentM7ki3MkadRGP9bpO7yFhHmgSYy0R9luZ6yh_s45el0AMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmXdIIl_45mc0vp_2wSO2Eq17zZbtpw6TfDrWe4oWQKUTFUMeta } from "/codebuild/output/src679198107/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateSv_45xVXqP_459ccuI7e9QSNEFw1vMUYBh6yNNd65fcq1QEMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completepDR_450RcYsf5i0oUbFBA3CYP_tW6qm3K0pxbtThzfKvEMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeKJXmdWcBNoJ5H_45JPcq52Sk_qAhd3YYI4XtTTW_453MEfcMeta } from "/codebuild/output/src679198107/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordwVV21mkOG5D5Odv_OXjZ302_FbpAj_K694Fjy4uh4l4Meta } from "/codebuild/output/src679198107/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliastSMnIZtXcDz8PPZqIC1wmbxnjCrTsSv543pHQr6ltfwMeta } from "/codebuild/output/src679198107/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register_tl7lrYYvwenGeHYkBYU9wn_45k1kdfshdr0QQR9PdWdoMeta } from "/codebuild/output/src679198107/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code46X9aw_dofciUrO5pWE0iTwYYPaHnMr4UfjIvDFsDiEMeta } from "/codebuild/output/src679198107/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexn1_4CZFX8XQgrT_45aJVbC7wpW7AnO_45Omo8bWsxjkyKjgMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexnISPOT1smurYKF0hN_45eI0qOJGsbNXWCX4UVb0TR4yrcMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index3ETbJlnPhILHH1s81C6_FAx7SSm5PkAEBYhytjD48YYMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNRCQpxpBA3z_45CSoimOpuc60Z6MwQObKddYVbwm_45MTF8Meta } from "/codebuild/output/src679198107/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatefedqWMIycPN2FXzVTjTMbk3DARArWXme6WsMorX2_456EMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completers7Zw5PKGViMXV1MTbbo6Aiya2m9Vq18yTFfkVroXEgMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmAUHDts6oxz_nAsDN9glm8hodGfQ9z7IWJ7kHgF8FyYcMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexjsQz_m1BK_6F35XUaq7q25dAgouFOT0kLexAjimr4HIMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeVNTWTHpnew1zliy4nd9ORXAjamzwGZusI_AHDTlfRPAMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateD7mwxMsLvK9ejqrIAlUjWRqg4TqGV_kONKRCIhVY48YMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexuXNJZy5TC_45zxanLvWpb7aYqUaHf0TODDT2BpXfZ2gK8Meta } from "/codebuild/output/src679198107/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexIcioLooBBK7bu0dk4Wu5LZgTR964g1UuWkQ85LCnm0UMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completegF_45uDT6fZnytx7udKvujx1XudXTL0eA5KUX04sA35hUMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexLronuYNLnmDHLMFhP6YJw54NR57jChUc_bBIRtDn3JoMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeoSLoI87n_mw_45pQuTHSqQ6hh71P4jCrQQ6kzLadKahowMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexFzwEswfJq_45V3qDhG0hqGaKZm3XNj_33RrYGm33MNF5EMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexuAWCB0KwHteHqyGPv0rbqhMmbjgRRHuA4M_5m6xwTIEMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexwxIuDYEeHXsP2kjFTpyJsJq1psI5YacM7y3OlFAL_45dwMeta } from "/codebuild/output/src679198107/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatekPw8hKpDDb8v5_45wkRVdMfFUH1A2kQQr5z63i_45Xi936kMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirma1RNU4VP8dQ1LUJlkxc85BYjL7_459gJUekpQTDFALUZYMeta } from "/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src679198107/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuOtMezixSCuhkJfXBKrk9L_ZksmYSnTDFOztyJs07MAMMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexRmG8LJkuLP6_MdNiOl2XyTFX02wd7QW09bXRb1MzAw4Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src679198107/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src679198107/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src679198107/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src679198107/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src679198107/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexqhKwI0GywhzZu0pJ1cQe_I0QEWaNm6fixFQV1J_V6_kMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexUO6jfyzT9Q_45whPYG8ECqUCqyQgX7mhprBVtI0tHBVTUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexy_aG8Dp8KtciSR9KpmFWNRY37K2b3BbYTyWkUbTogowMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexubO9dSt40eea762PtDz0uGGxGbZ4eC2NE2QCMcdLOE4Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src679198107/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src679198107/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index8O57Kpgu7iqzPCLnXhDMHDGansPFnXxoZK3czW99dM4Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmyHGNjV2EsrV9w7MnbNoF1MKFwQib3GRpY2m6pr39CRoMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm02_450d2GDhuvCxtFQPbMPAcew5arsZavX9mJtG6V7CHwMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeF6j7OXzTc5TB_459tzXY0Bf2k3bxXARnYZ3fOpZdQs9P8Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registersoIbhQtakEGRttPsrp8YLnowNi9Fk8bn0c3WpODB750Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmd1ZwxvEuDdF_h73MGLMoEJ2HN9frxlGznYwIqeaxWlQMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codePxw6gCYoIZoRzUS9fUcqoA9q8hr_4570qyfYsHH_cWbT0Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeq80dyD3Chf1y6RGcalvnfW_igxi2pd8DlnlyVrUbikcMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completevHM6tU8uH7oWdCk9Pt8NuIgWfTp_45JAuJGP5ZDy5YypEMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerNU1qqcXoS42a3msgslCXYYl4JfV6crIWc1VUx1SJqdsMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmf1A3H8Fz4Ik6W8UCug_hu9z4YI2B_45t3IziwHUulxA3QMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeHd1V4TMs5lLYBM7JsXN44NyhP76tmIL7PPBa946DfKwMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexgpJquRuzOL_PNzqjWTSDtnHV2GpIpsmi32QKCuzFbrkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completebwp3utEtcw2uY3wtNeHQ4gP1A0eGUp66yzjArDOZlAYMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample2cWq1yZH0yw6K1aMcEkWXZRI6vzLdM_s6itjIkSVMnkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailBtHJy84As0Me_457v2hi5I6wbfJnPjNEdx9hnvb1KiGjUMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmgd0nUwhGipJt_ljKvl4JnEyg_G5y0uDFkT4PSJeLr_45MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentM7ki3MkadRGP9bpO7yFhHmgSYy0R9luZ6yh_s45el0AMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmXdIIl_45mc0vp_2wSO2Eq17zZbtpw6TfDrWe4oWQKUTFUMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completepDR_450RcYsf5i0oUbFBA3CYP_tW6qm3K0pxbtThzfKvEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeKJXmdWcBNoJ5H_45JPcq52Sk_qAhd3YYI4XtTTW_453MEfcMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordwVV21mkOG5D5Odv_OXjZ302_FbpAj_K694Fjy4uh4l4Meta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src679198107/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register_tl7lrYYvwenGeHYkBYU9wn_45k1kdfshdr0QQR9PdWdoMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code46X9aw_dofciUrO5pWE0iTwYYPaHnMr4UfjIvDFsDiEMeta || {},
    component: () => import("/codebuild/output/src679198107/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src679198107/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src679198107/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]